import React, { useState, useEffect } from 'react';
import useEvents from '../hooks/useEvents';
import EventCard from './EventCard';
import BrandedLoading from "../../common/BrandedLoading";
import EmptyMessage from '../../common/EmptyMessage';
import { Table, TableBody, TableHead, TableRow, TableCell, Checkbox, Pagination } from "@mui/material";
import { NameTableCell, MessageTableCell, DateTableCell, StatusTableCell, ActionTableCell } from "./tableCells";

const Events = ({ eventType, refresh, newEvent, inProgressEventId, setInProgressEventId, selectedEvents, setSelectedEvents, permissions }) => {
    const { events, isLoading, handleDeleteEvent, refreshFunction, sendFunction, handelCancel, fetchEvents, updateEvent, handleArchive } = useEvents(eventType, refresh, newEvent, inProgressEventId, setInProgressEventId);
    const [selectAll, setSelectAll] = useState(false);
    const [page, setPage] =useState(0)
    const rowsPerPage = 10

    const filteredEvents = eventType === "email" ? events.filter(event => !event.isArchived) : events;

    const sortedEvents = filteredEvents.slice().sort((a, b) => {
        if (a.status === 'Yet to Send' && b.status !== 'Yet to Send') return -1;
        if (a.status !== 'Yet to Send' && b.status === 'Yet to Send') return 1;
        return new Date(b.date) - new Date(a.date);
    });

    const paginationEvents = sortedEvents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    useEffect(() => {
        const currentPageEventIds = paginationEvents.map(e => e._id);
        const allSelected = currentPageEventIds.length > 0 && currentPageEventIds.every(id => selectedEvents.includes(id));
        setSelectAll(allSelected);
    }, [page, selectedEvents, paginationEvents]);

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);

        const currentPageEventIds = paginationEvents.map(event => event._id);

        setSelectedEvents(prevSelected => {
        if (isChecked) {
                const newSelected = [...prevSelected];
                currentPageEventIds.forEach(id => {
                if (!newSelected.includes(id)) newSelected.push(id);
            });
            return newSelected;
        } else {
            return prevSelected.filter(id => !currentPageEventIds.includes(id));
        }
        });
    };

    const handleChangePage = (event, newPage) => setPage(newPage - 1);

    return (
        <div>
            {isLoading ? (
                <BrandedLoading />
            ) : filteredEvents.length === 0 ? (
                <EmptyMessage message={`No ${eventType} to show.`} />
            ) : (
                <div style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox">
                                    <Checkbox checked={selectAll} onChange={handleSelectAll}/>
                                </TableCell>
                                <NameTableCell>Name</NameTableCell>
                                <MessageTableCell>Message</MessageTableCell>
                                <DateTableCell>Date</DateTableCell>
                                <StatusTableCell>Status</StatusTableCell>
                                <ActionTableCell>Actions</ActionTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginationEvents.map((event) => (
                                <EventCard
                                    key={event._id}
                                    event={event}
                                    handleDelete={handleDeleteEvent}
                                    inProgressEventId={inProgressEventId}
                                    setInProgressEventId={setInProgressEventId}
                                    sendFunction={sendFunction}
                                    refreshFunction={refreshFunction}
                                    handelCancel={handelCancel}
                                    eventType={eventType}
                                    fetchEvents={fetchEvents}
                                    updateEvent={updateEvent}
                                    selectedEvents={selectedEvents}
                                    setSelectedEvents={setSelectedEvents}
                                    permissions={permissions}
                                    handleArchive={handleArchive}
                                />
                            ))}
                        </TableBody>
                    </Table>
                    <div style={{ display: 'flex', justifyContent: 'center', margin: '16px' }}>
                        <Pagination count={Math.ceil(filteredEvents.length / rowsPerPage)} page={page + 1} onChange={handleChangePage} color="primary"/>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Events;
